import type { PlayerRatingAllResponse } from '@on3/api';
import clsx from 'clsx';

import styles from './IndustryComparisonFourServicesItem.module.scss';
import { IndustryComparisonServiceItem } from './IndustryComparisonServiceItem';

interface IndustryComparisonFourServicesItemProps {
  ratings?: PlayerRatingAllResponse[] | null;
  psoKey?: number | null;
  slug?: string | null;
  sport?: string | null;
  className?: string;
  selected?: string | null;
  /**Show jersey or overall rank column */
  showJerseyOrRank?: boolean;
}
export const IndustryComparisonFourServicesItem = ({
  ratings,
  psoKey,
  slug,
  className,
  selected,
  showJerseyOrRank,
}: IndustryComparisonFourServicesItemProps) => {
  return (
    <div className={clsx(styles.starRatingsContainer, className)}>
      {ratings
        ?.filter(
          (rating) => rating.type !== 'Industry' && rating.type !== 'Consensus',
        )
        .map((starRating, index) => {
          return (
            <IndustryComparisonServiceItem
              key={`${psoKey}-${index}`}
              {...starRating}
              selected={selected}
              showJerseyOrRank={showJerseyOrRank}
              slug={slug}
            />
          );
        })}
    </div>
  );
};
